var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAviaoDePapel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345 280",
    width: 345,
    height: 280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #A7DEF3;stroke: #000000;stroke-miterlimit:100 } \n\t\t.s1 { fill: #CAF4FF;stroke: #000000;stroke-miterlimit:100 } \n\t\t.s2 { fill: none;stroke: #000000;stroke-miterlimit:100;stroke-dasharray: 4,2 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "airplane-shadow",
    className: "airplane s0",
    d: "m230.4 117.3c0 0 23.6 42.6 26.6 38.6 0-5.6-0.3-28.5-0.3-28.5 0 0 54.2-79.6 58.5-85.7-1.2-5.6-6.3-4.1-6.3-4.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "airplane-wrap",
    className: "airplane s1",
    d: "m187.3 91.2c-7.2 4.3-1.3 9-1.3 9l44.3 16.3c0 0 74.8-74.2 79.1-78.5 6.5-1.5 4.6 4.6 4.6 4.6l-57.4 83.4c0 0 0.4 25.8 0.5 30.2 2.7 2.1 4.6-0.4 4.6-0.4l17.9-20.5c0 0 40.1 15 46.7 17.4 6.5 2.3 7-5.1 7-5.1 0 0 10.5-136.3 10.7-142.4 0.2-6-6.6-3.9-6.6-3.9 0 0-142.2 86.9-150.1 89.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "airplane-track",
    className: "s2",
    d: "m256.4 168.6c0 0-52.4 32.2-108.5 42.5-40.6 7.4-81.7 4.3-102.6-20.9-20.9-25.2-17.7-64.1 8.6-86 26.3-21.9 86.3-5.2 96.4 23.9 17.7 51 2.5 113.1-35 140.1-37.5 27-114.8-3.7-114.8-3.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviaoDePapel);
export default __webpack_public_path__ + "static/media/aviao_de_papel.2f8e841d59df127d6276fdef129a1a8b.svg";
export { ForwardRef as ReactComponent };